exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-container[data-v-d3167874]{text-align:center}.empty-container .empty-icon[data-v-d3167874]{width:2.34666667rem;height:2.34666667rem;margin:0 auto .53333333rem}.empty-container .empty-icon[data-v-d3167874] img{width:100%;height:100%}.empty-container .empty-title[data-v-d3167874]{font-size:.42666667rem;font-weight:700;color:#7f7f7f;line-height:.61333333rem;margin-bottom:.09333333rem}.empty-container .empty-desc[data-v-d3167874]{font-size:.34666667rem;font-weight:400;color:#999;line-height:.61333333rem}", ""]);

// exports
